import Button from '@mui/material/Button';
import { GridColDef } from '@mui/x-data-grid';
import { useNavigate } from "react-router-dom";
import { deleteVideo } from '../../../services/video';
import ImgThumb from '../../ImgThumb';

const useProductosTable = () => {

    const navigate = useNavigate()

    const columns: GridColDef[] = [
       
        {
            field: 'nombre',
            headerName: 'Titulo',
            width: 200
        },
        {
            field: 'sku',
            headerName: 'SKU',
            width: 200
        },
        {
            field: 'categoria',
            headerName: 'Categoria',
            width: 200,
            //renderCell: (e) => <ImgThumb src={e.value} />
        },
        {
            field: 'visitas',
            headerName: 'Visitas',
            width: 200,
            //renderCell: (e) => <ImgThumb src={e.value} />
        },
        {
            field: 'descargable',
            headerName: 'Descargable',
            width: 200,
        },
        {
            field: 'imagen_principal',
            headerName: 'Imagen principal',
            width: 200,
            renderCell: (e) => <ImgThumb src={e.row.imagen_principal} />
        },
        
        {
            field: 'acciones',
            headerName: 'Acciones',
            width: 200,
            renderCell: (e) => {
                return <div style={{
                    display: 'flex',
                    gap: 4,
                }}>
                    {/*<Button variant="contained" onClick={() => {
                        navigate(`/blog/${e.id}`)
                    }}>Ver</Button>*/}
                    <Button variant="contained" style={{ backgroundColor: 'transparent'}} onClick={() => {
                        navigate(`/producto/${e.id}`)
                    }}>
                          <img src={'./assets/img/editar.png'} alt="Button Image" style={{ width: '20px', height: '20px' }} />
                 
                    </Button>

                </div>
            }
        },
    ];

    return {
        columns
    }

}

export default useProductosTable